import { LockRewardStore } from "../../lock-reward-store"
import { LockRewardStoreNftGroup } from "../../types"
import { LockRewardGroupingStrategy } from "./lock-reward-grouping-strategy"

export class ByNftGroupingStrategy implements LockRewardGroupingStrategy<Map<number, LockRewardStoreNftGroup>> {
  group(rewards: LockRewardStore[]): Map<number, LockRewardStoreNftGroup> {
    const grouped = new Map<number, LockRewardStoreNftGroup>()

    rewards.forEach((reward) => {
      const nftId = reward.nftId

      if (!grouped.has(nftId)) {
        grouped.set(nftId, {
          nftId,
          tokens: new Map(),
          totalValueUSD: 0,
        })
      }

      const nftGroup = grouped.get(nftId)!
      const tokenAddress = reward.token.address.toViemAddress()

      if (!nftGroup.tokens.has(tokenAddress)) {
        nftGroup.tokens.set(tokenAddress, {
          tokenAddress,
          rewards: [],
          totalValueUSD: 0,
        })
      }

      const tokenGroup = nftGroup.tokens.get(tokenAddress)!
      tokenGroup.rewards.push(reward)
      tokenGroup.totalValueUSD += reward.valueUSD
      nftGroup.totalValueUSD += reward.valueUSD
    })

    return grouped
  }

  strategyName(): string {
    return "by-nft"
  }
}
